import { useAuth0 } from "@auth0/auth0-react";
import styles from "./addcontact.module.css";
import { Autocomplete, Checkbox, Chip, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import axios from 'axios';
import { toast } from 'react-smart-toaster';
import { useEffect, useState } from "react";
import { createFilterOptions } from '@mui/material/Autocomplete';

const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option) => option.name,
    ignoreCase: true,
    trim: true
});

const AddContact = ({ groupDetails, setAddModalOpen, setLoading, setSnackbarOpen, setSnackbarMsg, setGroupDetails }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [selectContact, setSelectContact] = useState([]);
    const [contactList, setContactList] = useState([]);
    const [selectContactIds, setSelectContactIds] = useState([]);

    useEffect(() => {
        const getProspectList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_USER_API_URL + "v1/campaign/all-prospect-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setContactList(response.data.data);
            }).catch(() => {
            });
        }

        const getContactList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_USER_API_URL + "v1/campaign/all-contact-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setContactList(response.data.data);
            }).catch(() => {
            });
        }

        const getTenantList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_USER_API_URL + "v1/campaign/all-tenant-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setContactList(response.data.data);
            }).catch(() => {
            });
        }

        if (groupDetails && groupDetails?.type) {
            if (groupDetails?.type === 'Prospect') {
                getProspectList();
            }

            if (groupDetails?.type === 'Tenant') {
                getTenantList();
            }

            if (groupDetails?.type === 'Contact') {
                getContactList();
            }
        }
    }, [groupDetails, getAccessTokenSilently]);

    useEffect(() => {
        let ids = selectContact.map((i) => {
            return i.id;
        });

        setSelectContactIds(ids);
    }, [selectContact]);

    const addConatcts = async () => {
        if (selectContact.length === 0) {
            toast.error('Please select contact');
            return false;
        }

        setLoading(true);
        setAddModalOpen(false);

        let data = [];

        if (groupDetails?.type === 'Prospect') {
            data = selectContactIds?.map(i => {
                return { prospect_id: i };
            });
        }

        if (groupDetails?.type === 'Tenant') {
            data = selectContactIds?.map(i => {
                return { tenant_id: i };
            });
        }

        if (groupDetails?.type === 'Contact') {
            data = selectContactIds?.map(i => {
                return { contact_id: i };
            });
        }

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.post(process.env.REACT_APP_USER_API_URL + 'v1/campaign/groups/' + groupDetails?.id + '/contacts', { data: data }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then(response => {
            setSnackbarOpen(true);
            setSnackbarMsg('Group added successfully.');

            setLoading(false);

            setGroupDetails(prev => {
                return { ...prev, contacts: response.data.data.concat(prev.contacts) };
            });
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<div className={`${styles.AddPropertyRow}`}>
        <div className={`${styles.AddPropertyHalfSec}`}>
            <div className={`${styles.AddPropertyHalfSecRow}`}>
                <div className={`${styles.HalfSecHalf} FormGroup`}>
                    <TextField id="outlined-basic" label="Group Name*" variant="outlined" defaultValue={groupDetails?.title} disabled />
                </div>
                <div className={`${styles.HalfSecHalf} FormGroup`}>
                    <FormControl fullWidth disabled>
                        <InputLabel id="demo-simple-select-label">Type*</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Type*"
                            defaultValue={groupDetails?.type}
                        >
                            <MenuItem value={groupDetails?.type}>{groupDetails?.type}</MenuItem>
                        </Select>
                    </FormControl>
                </div>
                <div className={`${styles.HalfSecFull} FormGroup GroupChip`}>
                    <Autocomplete
                        multiple
                        id="checkboxes-tags-demo"
                        options={contactList}
                        disableCloseOnSelect // Keep dropdown open on selection
                        getOptionLabel={(option) => option.name}
                        filterOptions={filterOptions}
                        value={selectContact} // Controlled value
                        onChange={(event, newValue) => {
                            setSelectContact(newValue);
                        }}
                        renderOption={(props, option) => (
                            <MenuItem {...props} disabled={option?.email === ''}>
                                <Checkbox checked={selectContactIds.indexOf(option.id) > -1} />
                                {option.name.trim() !== '' ? option.name : option?.email}
                                {option?.email === '' && <span className={`${styles.NoMailDR}`}>No Email</span>}
                            </MenuItem>
                        )}
                        renderTags={(tagValue, getTagProps) =>
                            tagValue.map((option, index) => (
                                <Chip
                                    key={index} // Key is important for performance
                                    label={option.name.trim() !== '' ? option.name : option?.email}
                                    {...getTagProps({ index })} // Spreads necessary props for deletion etc.
                                    onDelete={() => {
                                        const newSelection = [...selectContact];
                                        newSelection.splice(index, 1);
                                        setSelectContact(newSelection);
                                    }}
                                />
                            ))
                        }
                        renderInput={(params) => (
                            <TextField {...params} label="Contacts" placeholder="Select Contacts" />
                        )}
                    />
                </div>
            </div>
        </div>
        <div className={`${styles.ButtonSec}`}>
            <button type="button" onClick={(e) => setAddModalOpen(false)} className="CancelPopupBU">Cancel</button>
            <button type="button" className="SubmitPopupBU" onClick={(e) => addConatcts()}>Add</button>
        </div>
    </div >);
}

export default AddContact;